export class FlappyInput {
  private readonly onPointerDown = (event: PointerEvent): void => {
    event.preventDefault();
    this.onFlap();
  };
  private readonly onKeyDown = (event: KeyboardEvent): void => {
    if (event.code !== "Space") return;
    event.preventDefault();
    this.onFlap();
  };

  constructor(private readonly canvas: HTMLCanvasElement, private readonly onFlap: () => void) {}

  attach(): void {
    this.canvas.addEventListener("pointerdown", this.onPointerDown, { passive: false });
    window.addEventListener("keydown", this.onKeyDown);
  }

  detach(): void {
    this.canvas.removeEventListener("pointerdown", this.onPointerDown);
    window.removeEventListener("keydown", this.onKeyDown);
  }
}
